import React from 'react';

import { formatCurrency, formatPercent } from 'utils';

interface TooltipPayload {
    name: string;
    value: number;
    payload: {
        isFromSelectedAccount?: boolean | null;
        selectedAccountValue?: number | null;
    };
}

interface TooltipProps {
    active?: boolean;
    payload?: TooltipPayload[];
    total: number;
}

export const CustomTooltip = ({ active, payload, total }: TooltipProps) => {
    if (active && payload && payload.length) {
        const entry = payload[0];

        // Only show tooltip for highlighted segments when account is selected
        if (entry.payload.isFromSelectedAccount === false) {
            return null;
        }

        const percentage = total > 0 ? (entry.value / total) * 100 : 0;

        return (
            <div className="z-50 rounded-lg border bg-white p-3 shadow-lg">
                <p className="font-semibold">{entry.name}</p>
                <p className="text-sm text-gray-600">
                    {formatCurrency(entry.value)} ({formatPercent(percentage)})
                </p>
            </div>
        );
    }
    return null;
};
